import { render, staticRenderFns } from "./1V1.vue?vue&type=template&id=9cbd5bea&scoped=true"
import script from "./1V1.vue?vue&type=script&lang=js"
export * from "./1V1.vue?vue&type=script&lang=js"
import style0 from "./1V1.vue?vue&type=style&index=0&id=9cbd5bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbd5bea",
  null
  
)

export default component.exports